import React from 'react';
import type { ImmunizationModel } from './types';
import { deletePatientImmunizationOptions, getImmunizationsOptions, ImmunizationTypeEnum } from '@generated';
import { useMutation } from '~/util/http/useMutation';
import { DataTable } from '~/shared/data-tables/DataTable';
import { PatientImmunizationFormModal } from './forms/PatientImmunizationFormModal';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';
import { TableActions } from '~/shared/data-tables/TableActions';

function RenderActionsCell(props: ImmunizationModel) {
	const deleteImmunizaion = useMutation({
		...deletePatientImmunizationOptions,
		invalidateQueryKeys: [getImmunizationsOptions(props.stayId).queryKey]
	});
	const onRemove = () => {
		if (confirm('Are you sure you want to remove this immunization?')) {
			deleteImmunizaion.mutate({ stayId: props.stayId, patientPhysicianId: props.id });
		}
	};
	return (
		<TableActions>
			<TableActions.ViewButton
				renderModal={closeModal => (
					<PatientImmunizationFormModal stayId={props.stayId} existingImmunization={props} closeModal={closeModal} />
				)}
			/>
			<TableActions.DeleteButton onClick={onRemove} isPending={deleteImmunizaion.isPending} />
		</TableActions>
	);
}

const columns: DataTableColumnProps<ImmunizationModel>[] = [
	{
		key: 'immunizationTypeLabel',
		header: 'Type',
		renderCell: d => (d.immunizationTypeId === ImmunizationTypeEnum.Other ? d.immunizationTypeOther : d.immunizationTypeLabel)
	},
	{
		key: 'immunizationAdministererLabel',
		header: 'Administered By'
	},
	{
		key: 'dateAdministered',
		header: 'Date Administered',
		renderCell: d => (d.dateAdministered ? new Date(d.dateAdministered).toLocaleDateString() : 'N/A')
	},
	{
		key: 'actions',
		header: 'Actions',
		width: 'w-24',
		renderCell: d => <RenderActionsCell {...d} />
	}
];

export function ImmunizationsTable({ rows }: { rows: ImmunizationModel[] }) {
	return (
		<DataTable
			columns={columns}
			rows={rows}
			viewMore={{
				text: 'View Additional Immunizations',
				threshold: 3
			}}
			getRowNotes={x => x.notes ?? null}
		/>
	);
}
